import { Lookup } from "../Lookup";
import LookupTypes from "../LookupTypes";
import { SearchTerm } from "../search/SearchTerm";
import { TableColumn } from "../table/TableColumn";

export const extendColumnDefinition = (columns: TableColumn[], extender: string): TableColumn[] => {
    return columns.map((column) => {
        return {
            ...column,
            sortByName: column.sortByName ? `${extender}.${column.sortByName}` : column.sortByName,
            searchOnName: column.searchOnName ? `${extender}.${column.searchOnName}` : column.searchOnName,
            lookupName: column.lookupName ? `${extender}.${column.lookupName}` : column.lookupName,
        }
    });
}

export const extendSearchColumn = (searchColumns: SearchTerm[], extender: string): SearchTerm[] => {
    return searchColumns.map(searchColumn => {
        return {
            ...searchColumn,
            searchOnName: `${extender}.${searchColumn.searchOnName}`,
        }
    })
}

export const hideColumns = (columns: TableColumn[], columnsToHide: string[]): TableColumn[] => {
    return columns.map(column => {
        return {
            ...column,
            active: columnsToHide.indexOf(column.accessor) !== -1 ? false : column.active
        }
    })
}

export const removeColumns = (columns: any[], columnsToRemoved: string[]): any[] => {
    return columns.filter((column) => !columnsToRemoved.includes(column.accessor));
}

export const extendLookups = (lookup: Lookup[], extendUsing: string): Lookup[] => {
    return lookup.map((current) => {
        if (current.name === LookupTypes.days) {
            return current;
        }
        return {
            ...current,
            name: extendUsing + '.' + current.name,
        }
    })
};

/**
 * Hide lookup for specific columns by accessor name
 */
export const hideLookups = (columns: TableColumn[], columnsToHideLookup: string[]): TableColumn[] => {
    return columns.map(column => {
        if (columnsToHideLookup.includes(column.accessor)) {
            return {
                ...column,
                hideLookup: true
            };
        }
        return column;
    });
};

